import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { Warning } from '@mui/icons-material';

const CashCoursePaymentModal = ({ open, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}} // Disable closing on escape or overlay click
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="warning" />
        Attenzione - Pagamento in Contanti
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Scegliendo questa opzione la tua iscrizione rimarrà in sospeso fino a quando non concluderai il pagamento. 
          Avrai intanto la possibilità di partecipare alle attività del corso.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={onCancel} variant="outlined">
          Annulla
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CashCoursePaymentModal; 